import { FileError } from "react-dropzone";
import openToast from "utils/openToast";

const defaultValidator = (
  file: File,
  acceptedFormats?: string[] | string,
): FileError | null => {
  if (
    acceptedFormats &&
    acceptedFormats.length > 0 &&
    Array.isArray(acceptedFormats) &&
    !acceptedFormats.includes(file.type)
  ) {
    openToast("The selected format is not available", "error");

    return {
      code: "file-invalid-type",
      message: "The selected format is not available",
    };
  }

  return null;
};

export default defaultValidator;
